import { useState } from "react";
import "./style.scss"; // optional
import { FaChevronDown } from "react-icons/fa";

const FAQItem = ({ question, children }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="faq-item">
      <div
        className="faq-question"
        onClick={() => setOpen(!open)}
      >
        {question}      
        <FaChevronDown
            className={`faq-chevron ${open ? "open" : ""}`}
          />
      </div>
      
      <div className={`faq-answer ${open ? "open" : ""}`}>
        {children}
      </div>

    </div>
  );
};

export default FAQItem;
